import { render, staticRenderFns } from "./send-email.dialog.vue?vue&type=template&id=359d0730&scoped=true"
import script from "./send-email.dialog.vue?vue&type=script&lang=js"
export * from "./send-email.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359d0730",
  null
  
)

export default component.exports